import React from 'react'

interface Props {
  children: string
  active: boolean
  onClick: () => void
}

const HourButton = ({ children, active, onClick }: Props) => {
  const functionClasses = (active: boolean) => {
    if (active) {
      return 'bg-slateGray text-white border border-white'
    }
    return 'border-slateGray text-slateGray bg-white border'
  }
  return (
    <div
      onClick={onClick}
      className={`text-18 rounded-xl p-3 px-4 cursor-pointer min-w-[6.6rem] flex items-center justify-center ${functionClasses(
        active
      )}`}>
      {children}
    </div>
  )
}

export default HourButton
